import React, { useEffect, useState } from 'react';

import buildingStyles from 'styles/buildingStyles';
import { getCollectionImageWithSize } from 'data/buildingApi';

const CollectionThumbImage = props => {
	const classes = buildingStyles();
	const collection = props.collection;
	const [imageData, setImageData] = useState(null);
	const [imageIsLoaded, setImageIsLoaded] = useState(false);

	useEffect(() => {
		const getImageData = async () => {
			let data = await getCollectionImageWithSize(collection.uuid, collection.images[0], 100);

			if (data) {
				setImageData(data);
				setImageIsLoaded(true);
			}
		}

		if (!imageIsLoaded && collection.images && collection.images.length) {
			getImageData();
		}
	}, [collection, imageIsLoaded]);

	return (
		<>
			{imageData ? 
				<div className={classes.thumbsImage} style={{ backgroundImage: 'url("' + imageData + '")' }}></div>
				:
				<div className={classes.thumbsImage} style={{ backgroundColor: '#ccc' }}></div>
			}
		</>
	)
}

export default CollectionThumbImage;
